import { faCheck, faClose, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Stack } from "react-bootstrap";
import { deleteJob, patchJob } from "../../../services/httpClient";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import IconButton from "../../ui/IconButton";

interface CardState {
  job: any;
  getJobs: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const JobCard = ({ job, getJobs, setOrgToSave, setErrMessage, setShowToast, setToastText, setToastBody }: CardState) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [jobName, setJobName] = useState<string>(job?.name);
  const [positionsTotal, setPositionsTotal] = useState<string>(job?.positions_total);

  useEffect(() => {
    setJobName(job?.name);
    setPositionsTotal(job?.positions_total);
  }, [job]);

  const onClickEdit = () => {
    setIsEditing(true);
  };

  const onClickEditFinal = async () => {
    if (job?.positions_filled > positionsTotal) {
      setErrMessage("Cannot Set Positions Total Less Than Positions Filled");
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
      return;
    }

    const updatedJob = {
      name: jobName,
      positions_total: positionsTotal,
    };

    await patchJob(updatedJob, job?.department_id, job?.id)
      .then((res: any) => {
        unsavedChanges.value = false;
        setOrgToSave(false);
        setShowToast(true);
        setToastText("Job Updated");
        setToastBody(jobName);
        setIsEditing(false);
        getJobs(true);
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelEdit = () => {
    unsavedChanges.value = false;
    setOrgToSave(false);
    setIsEditing(false);
    setErrMessage(undefined);
  };

  const onUpdateName = (e: any) => {
    setJobName(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
    setErrMessage(undefined);
  };

  const onUpdateTotal = (e: any) => {
    setPositionsTotal(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
    setErrMessage(undefined);
  };

  const onClickDelete = () => {
    setIsDeleting(true);
  };

  const onClickDeleteFinal = () => {
    deleteJob(job?.department_id, job?.id)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Job Deleted");
        setToastBody(job?.name);
        setIsDeleting(false);
        getJobs(true);
      })
      .catch((err: any) => {
        setIsDeleting(false);
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
    setErrMessage(undefined);
  };

  const renderEdit = () => {
    return (
      <Stack direction="horizontal" gap={3}>
        <Col xs={8}>
          <Input label="Job" type="text" value={jobName} onUpdate={(e: any) => onUpdateName(e)} />
        </Col>
        <Col>
          <Input label="Positions #" type="number" value={positionsTotal} onUpdate={(e: any) => onUpdateTotal(e)} />
        </Col>
        <Stack className="ms-auto" direction="horizontal" gap={3}>
          <IconButton onClickButton={onClickEditFinal} tooltipText={"Save"} icon={faCheck} />
          <div className="vr" />
          <IconButton onClickButton={onClickCancelEdit} tooltipText={"Cancel"} icon={faClose} />
        </Stack>
      </Stack>
    );
  };

  const renderDelete = () => {
    return (
      <Stack direction="horizontal" gap={3}>
        <Stack style={{ justifyContent: "center" }} gap={2}>
          <Card.Subtitle>Delete {job?.name}?</Card.Subtitle>
        </Stack>
        <Button className="app-danger-color button" onClick={() => onClickDeleteFinal()}>
          Confirm Delete
        </Button>
        <div className="vr" />
        <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
          Cancel
        </Button>
      </Stack>
    );
  };

  return (
    <Card key={job?.name}>
      <Card.Body>
        {isEditing ? (
          <>{renderEdit()}</>
        ) : isDeleting ? (
          <>{renderDelete()}</>
        ) : (
          <Stack direction="horizontal" gap={3}>
            <Col style={{ width: "20.5rem", overflow: "hidden", textOverflow: "ellipsis" }}>
              <small>{job.name}</small>
            </Col>
            <small>
              Positions: {job?.positions_filled}/{job?.positions_total}
            </small>
            <div className="vr" />
            <IconButton onClickButton={onClickEdit} tooltipText={"Edit"} icon={faEdit} />
            <div className="vr" />
            {job?.positions_filled > 0 ? (
              <IconButton tooltipText={"Must Unassign Jobs"} icon={faTrash} />
            ) : (
              <IconButton onClickButton={onClickDelete} tooltipText={"Delete"} icon={faTrash} />
            )}
          </Stack>
        )}
      </Card.Body>
    </Card>
  );
};

export default JobCard;
